import { render, staticRenderFns } from "./LogsCard.vue?vue&type=template&id=778d82de&"
import script from "./LogsCard.vue?vue&type=script&lang=js&"
export * from "./LogsCard.vue?vue&type=script&lang=js&"
import style0 from "./LogsCard.vue?vue&type=style&index=0&id=778d82de&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports